module.exports = __webpack_public_path__ + "img/edge_hiver_snow_park.e860e149.svg";